module.exports = __webpack_public_path__ + "static/media/_unknown.1b5e0453.png";